module.exports = __webpack_public_path__ + "img/metal_a@2x.5005179c.png";